<div class="dialog-content-wrapper-defaulters">
  <mat-toolbar matDialogTitle class="accent-600 m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <div class="contact-name mt-8">Aviso</div>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 pb-0 m-0">
    <div class="conteudo">
      <div id="info" class="defaulterMessage" >

      </div>
    </div>
    <br><br>
    <!-- <div fxLayoutAlign="end end" class>
      <h3 class="text-style">{{message}}</h3>
      <countdown [config]="{leftTime: 5, format: 's'}" (event)="handleEvent($event)"></countdown>
    </div> -->


    <!-- <div mat-dialog-actions class="m-0 p-16" class="actions" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="16px"> -->
    <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8">
      <button mat-raised-button (click)="openWhatsapp()" color="primary">
        <span>WhatsApp</span>
      </button>

      <button mat-raised-button [disabled]="disableButton" (click)="confirm()" color="primary">
        <span *ngIf="disableButton == false">OK</span>
        <span *ngIf="disableButton">
          <countdown [config]="{leftTime: 5, format: 's'}" (event)="handleEvent($event)"></countdown>
        </span>
      </button>
    </div>
  </div>